import { Wrapper, ServiceContainer, Image } from "./service-component.styles";
import { useAppContext } from "../../layout/layout";
import { Tilt } from "react-tilt";

const Service = ({ en_title, de_title, en_det, de_det, icon, bgIcon, img }) => {
  const { isDarkTheme, lang } = useAppContext();
  return (
    <Tilt style={{ height: "100%", width: "100%" }}>
      <Wrapper
        options={{
          max: 45,
          scale: 1,
          speed: 450,
        }}
      >
        <div>
          <h4>{lang === "en" ? en_title : de_title}</h4>
          <p>{lang === "en" ? en_det : de_det}</p>
        </div>
        <ServiceContainer>
          <div
            className={`service-demo-card transition-all absolute w-full text-center h-2/3 -bottom-4 overflow-hidden rounded-md shadow-md flex justify-center ${
              isDarkTheme ? "shadow-[#333]" : "shadow-[#bcccdc]"
            } `}
          >
            <Image
              src={`/assets/images/projects/${img}`}
              className="service-img"
              alt={en_title}
            />
          </div>
          <div
            className={`service-icon transition-all absolute bottom-[5.5rem] w-[50px] h-[50px] rounded-full border-1 border-[#bcccdc] ring-1 ring-[#d9e2ec] ${bgIcon} ring-offset-4  shadow-lg mx-0 flex justify-center items-center`}
          >
            <img
              src={`/assets/icons/${icon}`}
              className="w-10 h-10 bg-blend-lighten"
              alt="icon"
            />
          </div>
        </ServiceContainer>
      </Wrapper>
    </Tilt>
  );
};
export default Service;
